<template>
  <div class="m-todo-wrap">
    <div class="m-header">
      <span class="u-tt">{{$t('common.todo_center')}}</span>
      <a
        class="u-more"
        @click="handleTodoMore"
      >{{$t('common.more')}}></a>
      <i
        class="u-refresh h-icon-flash"
        @click="getTodoList"
      ></i>
    </div>
    <div class="m-main-ctn">
      <el-scrollbar wrap-class="m-scroll-wrap">
        <template v-if="list&&list.length>0">
          <div
            class="m-todo-column"
            v-for="item in list"
            v-loading="loading"
            @click="_handleOpenApp(item)"
            :key="item.msgId"
          >
            <span
              class="u-tt"
              :title="item.msgTitle"
            >{{item.msgTitle}}</span>
            <span class="u-status">{{item.msgStatusStr}}</span>
            <span class="u-date">{{item.msgCreateTime}}</span>
          </div>
        </template>
        <div
          v-else
          class="m-no-data"
        >
          <img src="../../../assets/images/no_data.png"><br>
          {{$t('common.no_data')}}
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import Api from '../../../api/api'
export default {
  data () {
    return {
      list: [],
      loading: false
    }
  },
  mounted () {
    this.getTodoList()
  },
  computed: {
    ...mapGetters(['tlnc'])
  },
  methods: {
    // 获取待办list
    getTodoList () {
      this.loading = true
      Api.common.getTodoList({ size: 10 }).then(res => {
        this.loading = false
        this.list = this._changeMsgCreateTime(res.data || [])
      }).catch(err => {
        this.loading = false
        this.$message.error(err.msg)
      })
    },
    _changeMsgCreateTime (list) {
      return list.map(_ => {
        return {
          ..._,
          msgCreateTime: this._verifyTime(_.msgCreateTimeIso, _.serverTime)
        }
      })
    },
    /* 处理 今天、昨天等 特殊需求
    * @params *sourcTime 待的参数 为标准 ISO 时间戳 - 分隔日期 eg: 2019-10-31T14:23:30.000+08:00
    * @params curTime 时间戳 eg: new Date().getTime()
    */
    _verifyTime (sourceTime, curTime) {
      let result = ''
      // 未传 curTime 时，使用本地. 本地化，需要处理一下
      curTime = curTime ? new Date(curTime).toISOString() : new Date().toISOString()

      sourceTime = this._formatTime(sourceTime)
      curTime = this._formatTime(curTime)

      // 得到日期时间戳。TS = timeStamp
      let oldTS = moment(sourceTime).format('YYYY-MM-DD')
      let curTS = moment(curTime).format('YYYY-MM-DD')
      // 对比
      let dayDiff = parseInt(moment(curTS).format('x')) - parseInt(moment(oldTS).format('x'))
      // 按天计
      switch (dayDiff / (1000 * 60 * 60 * 24)) {
        // case 用来产生不同天的需求
        case 0:
          result = this.$t('todo.card_time_today')
          break
        case 1:
          result = this.$t('todo.card_time_yesterday')
          break
        default:
          break
      }
      return result === '' ? sourceTime : (sourceTime.replace(oldTS, result))
    },
    _formatTime (isoTime, isEnableDST) {
      if (!isoTime) return ''
      isEnableDST = arguments.length === 1 ? window.localStorage.getItem('isEnableDST') : isEnableDST
      const momentTime = moment(isoTime)
      return momentTime
        .utcOffset(0 - new Date().getTimezoneOffset())
        .format(isEnableDST ? 'YYYY-MM-DD HH:mm Z' : 'YYYY-MM-DD HH:mm')
    },

    // 打开相应组件
    _handleOpenApp (todo) {
      window.openApp(todo)
    },
    // 打开待办组件
    handleTodoMore () {
      this.openMenu({
        value: this.$store.state.todoMenuId,
        key: 'menuId'
      })
    },
    // vuex
    ...mapActions(['openMenu'])
  }
}
</script>
<style lang="less" scoped>
.m-todo-wrap {
  box-sizing: border-box;
  padding: 0 16px 12px;
  background: #fff;
  .m-header {
    width: 100%;
    line-height: 52px;
    .u-tt {
      font-size: 14px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.9);
    }
    .u-refresh {
      float: right;
      margin-top: 18px;
      margin-right: 12px;
      cursor: pointer;
    }
    .u-more {
      float: right;
      font-size: 12px;
      text-decoration: none;
      color: #2196f3;
      opacity: 1;
      cursor: pointer;
    }
  }
  .m-main-ctn {
    width: 100%;
    height: calc(~"100% - 52px");
    box-sizing: border-box;
    /deep/ .m-scroll-wrap {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      top: 0;
      .m-no-data {
        width: 100%;
        padding: 30px 0;
        text-align: center;
        color: rgba(0, 0, 0, 0.4);
        font-size: 12px;
        img {
          width: 72px;
        }
      }
    }
    .m-todo-column {
      width: calc(~"100% - 8px");
      line-height: 26px;
      padding-left: 8px;
      cursor: pointer;
      overflow: hidden;
      span {
        display: block;
        float: left;
        font-size: 12px;
      }
      .u-status {
        width: 72px;
        color: rgba(0, 0, 0, 0.7);
        margin-left: 8px;
      }
      .u-date {
        width: 80px;
        height: 26px;
        color: rgba(0, 0, 0, 0.4);
        text-align: right;
        overflow: hidden;
      }
      .u-tt {
        width: calc(~"100% - 160px");
        color: rgba(0, 0, 0, 0.7);
        overflow: hidden; /*自动隐藏文字*/
        text-overflow: ellipsis; /*文字隐藏后添加省略号*/
        white-space: nowrap; /*强制不换行*/
      }
    }
    .m-todo-column:hover {
      background: rgba(30, 127, 255, 0.08);
    }
  }
}
</style>
